import React from 'react';
import { EventEditForm } from './EventEditForm';
import { useUsersList } from '../users/useUsersList';

export const EventEdit = () => {
  const users = useUsersList();
  return <EventEditForm users={users} />;
}